<div class="empty-state">
  <div class="empty-state__column top">
    <img class="empty-state__logo" src="/assets/img/etoll-logo.svg" alt="">
    <div class="empty-state__no-active">
      <span>
        {{ 'labels.inactive' | translate }}
      </span>
    </div>
  </div>
  <div class="empty-state__column bottom">
    <span class="empty-state__desc">
      {{ 'contactWithUsTitle' | translate }}
    </span>
    <span class="empty-state__contact">
      <a class="tel" href="tel:+48609111114">+48 609 111 114 lub </a> <a class="link" href="mailto:serwis@tekom.pl">serwis&#64;tekom.pl</a>
    </span>
  </div>
</div>
